export const prepareTourCardImageObject = (images) => {
  const reshapedImages = images.map((image) => ({
    image_url: image.large_url,
    alt: image.caption,
  }));

  return [...reshapedImages];
};
